import { ExclamationCircleOutlined } from "@ant-design/icons";
import confirm from "antd/lib/modal/confirm";
// import { AnalisisModal } from './modals/AnalisisModal';
import BarButtonFw, {
  BUTTON_DEFAULT,
} from "../../../framework/bar-button/BarButtonFw";
import { BasePage } from "../../../framework/pages/BasePage";
import { LoadUtil } from "../../../framework/util/LoadUtil";
import { EnvConstants } from "../../../EnvConstants";
import { UserUtil } from "../../../util/UserUtil";
import { getValidationGenerarCadenaModal } from "./getValidationGenerarCadenaModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { MessageUtil } from "../../../util/MessageUtil";
import FormFw from "../../../framework/form/FormFw";
import { PAGE_MODE } from "../../../constants/constants";
import GridFw, { COLUMN_DEFAULT } from "../../../framework/grid/GridFw";
import { AnalisisMuestraModal } from "./AnalisisMuestraModal";

export class EditarMuestraModel extends BasePage {
  constructor(props) {
    super(props);
    this.generarCadenaModal = {};
  }

  createPageProperties = (pageApi) => {
    return {
      validation: getValidationGenerarCadenaModal,
    };
  };

  renderPage(pageApi) {
    const getForm = () => pageApi.getComponent("form");
    const getGrid = () => pageApi.getComponent("grid");

    const fnDelete = (value, row, index) => {
      getGrid().deleteItem(row.key);
    };

    const analisisConfig = {
      events: {
        afterAddEvent: (data) => {
          let datos_grid = getGrid().getData();
          let find_data = datos_grid.find(
            (x) =>
              x.id_detalle_tarifa == data.id_detalle_tarifa &&
              x.descripcion_grupo == data.descripcion_grupo,
          );
          if (find_data) {
            return MessageUtil("warning", "Alerta!", "Ya Seleccionó el Item");
          }

          getGrid().addItem(data);
          getGrid().refresh();

          return MessageUtil("success", "Item agregado correctamente!", "");
        },
      },
    };

    const form = {
      layout: "vertical",
      collapsible: true,
      load: {
        queryId: 232,
        params: { id_doc: pageApi.name.id_ss },
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {
          if (pageApi.name.es_edicion) {
            getForm().setData({
              grupo: pageApi.name.grupo,
              id_matriz: pageApi.name.id_matriz,
              id_estacion: pageApi.name.id_estacion,
              cantidad: pageApi.name.cantidad,
            });

            getForm().mapFieldApi.id_estacion.load({
              params: {
                id_tipo_matriz: pageApi.name.id_tipo_matriz,
                id_empresa: pageApi.name.id_empresa,
              },
            });

            getGrid().load({
              params: {
                grupo: pageApi.name.grupo,
                id_doc_cotizacion: pageApi.name.id_doc_cotizacion,
                id_matriz: pageApi.name.id_matriz,
                id_rel_ss_estacion: pageApi.name.id_rel_ss_estacion,
                id_rel_cot_ana: 0,
              },
            });
          }
        },
      },
      fields: [
        { type: "hidden", name: "id_doc_cotizacion" },
        { type: "hidden", name: "id_doc" },
        {
          type: "select",
          name: "grupo",
          label: "Grupo",
          column: 6,
          load: { queryId: 595, params: { id_doc: pageApi.name.id_ss } },
          search: true,
          readOnly: pageApi.name.es_edicion === true,
        },
        {
          type: "select",
          name: "id_matriz",
          label: "Matriz",
          column: 6,
          load: { queryId: 596 },
          search: true,
          readOnly: pageApi.name.es_edicion === true,
          parents: [
            { name: "grupo", paramName: "grupo", required: true },
            { name: "id_doc", paramName: "id_doc", required: true },
          ],
          onChange: (value, form) => {
            let id_tipo_matriz = getForm()
              ?.getFieldApi("id_matriz")
              ?.getSelectedItem()?.id_tipo_matriz;
            let id_empresa = getForm()
              ?.getFieldApi("id_matriz")
              ?.getSelectedItem()?.id_empresa;
            getForm().mapFieldApi.id_estacion.load({
              params: { id_tipo_matriz, id_empresa },
            });
          },
        },
        {
          type: "select",
          name: "id_estacion",
          label: "Estación",
          column: 6,
          readOnly: pageApi.name.es_edicion === true,
          load: { queryId: 214 },
          search: true,
        },
        {
          type: pageApi.name.cantidad ? "number" : "hidden",
          name: "cantidad",
          label: pageApi.name.cantidad ? "Cantidad" : "",
          readOnly: pageApi.name.es_edicion === true,
          column: 6,
          value: 1,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const AnalisisModalConfig = (data) => {
      return {
        width: "950px",
        maskClosable: false,
        component: (
          <AnalisisMuestraModal
            name={data}
            getParentApi={pageApi.getApi}
            config={analisisConfig}
          />
        ),
      };
    };

    const barHeaderConfig = {
      fields: [
        {
          ...BUTTON_DEFAULT.SEARCH,
          label: "Agregar Análisis",
          onClick: () => {
            let obj = getForm().getData();

            if (
              obj?.grupo === undefined ||
              obj?.grupo === null ||
              obj?.grupo === ""
            ) {
              return MessageUtil("warning", "Alerta!", "Debe ingresar Grupo");
            }
            if (
              getForm().mapFieldApi?.id_matriz?.value === undefined ||
              getForm().mapFieldApi?.id_matriz?.value === null
            ) {
              return MessageUtil(
                "warning",
                "Alerta!",
                "Debe seleccionar Matriz",
              );
            } else {
              pageApi.showModal(AnalisisModalConfig(getForm()));
            }
          },
        },
      ],
    };
    
    const gridConfig = {
      title: "Datos de los Análisis",
      rowId: pageApi.name.es_edicion
        ? "id_rel_ss_muestras_cotizacion"
        : "id_rel_cot_ana",
      showIndex: true,
      pagination: {
        server: false,
      },
      autoLoad: false,
      collapsible: false,
      load: {
        validation: () => pageApi.name?.id_ss != null,
        queryId: pageApi.name.es_edicion ? 311 : 194,
        params: { id_doc: pageApi.name?.id_ss },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 978,
        params: {
          id: pageApi?.name?.id,
          id_rel_ss_estacion: pageApi?.name?.id_rel_ss_estacion || 0,
          grupo: pageApi?.name?.grupo,
          id_doc_cotizacion: pageApi?.name?.id_doc_cotizacion,
          id_matriz: pageApi?.name?.id_matriz,
          id_doc: pageApi?.name?.id_ss,
          id_user: UserUtil.getUserId(),
          id_muestreo: pageApi?.name?.id_muestreo, 
          numero: pageApi.name.numero,  
          id_cadena: pageApi.name.id_cadena, 
        },
        fnOk: (resp) => {
            debugger;
               if (resp?.dataObject == 1) {
               MessageUtil(" ", resp.message, "");
               }
               else {
                pageApi.getEvent("afterAddEvent")();
                pageApi.hideThisModal();
               }
        
        },
      },
      fields: [
        { name: "item", label: "Item", width: 200 },
        { name: "analisis", label: "Parámetro", width: 200 },
        {
          type: "select",
          name: "parametros",
          maxVisible: 2,
          label: "Sub Parámetros",
          labelName: "parametrosDes",
          search: true,
          multiple: true,
          multipleInString: true,
          editable: true,
          width: 300,
          load: {
            queryId: 305,
            params: () => {
              return {
                id_rel_metodo_matriz:
                  getGrid()?.itemEditing?.id_rel_metodo_matriz,
              };
            },
          },
          onChange: (values) => {
            getGrid().refresh();
          },
        },
        {
          ...COLUMN_DEFAULT.DELETE,
          label: "Opciones",
          title: "Eliminar",
          color: "red",
          colSpan: 1,
          onClick: fnDelete,
          width: 100,
        },
      ],
      barHeader: barHeaderConfig,
    };

    const bar = {
      fields: [
        {
          ...BUTTON_DEFAULT.SAVE,
          onClick: () => {
            debugger;
            if (pageApi.name.es_edicion) {
              getGrid().save();
            } else {
              let obj = getForm().getData();

              if (obj.grupo === undefined) {
                return MessageUtil(
                  "warning",
                  "Alerta!",
                  "Debe seleccionar Grupo",
                );
              }
              if (obj.id_matriz === undefined || obj.id_matriz === null) {
                return MessageUtil(
                  "warning",
                  "Alerta!",
                  "Debe seleccionar Matriz",
                );
              }
              if (obj.cantidad < 1) {
                return MessageUtil(
                  "warning",
                  "Alerta!",
                  "La cantidad no debe ser menor a 1",
                );
              }
              if (getGrid().getData().length === 0) {
                return MessageUtil(
                  "warning",
                  "Alerta!",
                  "Debe agregar por lo menos un análisis",
                );
              }
              getGrid().refresh();
              confirm({
                title:
                  "Está Seguro de guardar el grupo y Parámetros Seleccionados?",
                icon: <ExclamationCircleOutlined />,
                content: "",
                onOk() {
                  let datos = {
                    ...getForm().getData(),
                    grid: getGrid().getData(),
                    id_user: UserUtil.getUserId(),
                  };
                  LoadUtil.loadByQueryId({
                    url: EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                    queryId: 598,
                    params: datos,
                    fnOk: () => {
                      pageApi.getEvent("afterAddEvent")();
                      pageApi.hideThisModal();
                    },
                  });
                },
                onCancel() {},
              });
            }
          },
        },
        {
          ...BUTTON_DEFAULT.RETURN,
          alert: true,
          message: "Está seguro de retornar?",
          onClick: () => {
            pageApi.hideThisModal();
          },
        },
      ],
    };

    return (
      <>
        <FormFw name="form" getParentApi={pageApi.getApi} config={form} />

        <GridFw name="grid" getParentApi={pageApi.getApi} config={gridConfig} />

        <BarButtonFw name="bar" getParentApi={pageApi.getApi} config={bar} />
      </>
    );
  }
}

export default withRouter(EditarMuestraModel);
